"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.justErrorsLogger = exports.debugLogger = void 0;
/* eslint-disable no-console */ var getTimeStamp = require("@uppy/utils/lib/getTimeStamp"); // Swallow all logs, except errors.
// default if logger is not set or debug: false
var justErrorsLogger = {
    debug: function() {},
    warn: function() {},
    error: function error() {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (_console = console).error.apply(_console, [
            "[Uppy] [".concat(getTimeStamp(), "]")
        ].concat(_to_consumable_array(args)));
    }
}; // Print logs to console with namespace + timestamp,
// set by logger: Uppy.debugLogger or debug: true
exports.justErrorsLogger = justErrorsLogger;
var debugLogger = {
    debug: function debug() {
        var _console;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++){
            args[_key2] = arguments[_key2];
        }
        return (_console = console).debug.apply(_console, [
            "[Uppy] [".concat(getTimeStamp(), "]")
        ].concat(_to_consumable_array(args)));
    },
    warn: function warn() {
        var _console;
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++){
            args[_key3] = arguments[_key3];
        }
        return (_console = console).warn.apply(_console, [
            "[Uppy] [".concat(getTimeStamp(), "]")
        ].concat(_to_consumable_array(args)));
    },
    error: function error() {
        var _console;
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++){
            args[_key4] = arguments[_key4];
        }
        return (_console = console).error.apply(_console, [
            "[Uppy] [".concat(getTimeStamp(), "]")
        ].concat(_to_consumable_array(args)));
    }
};
exports.debugLogger = debugLogger;
